module.exports = __webpack_public_path__ + "static/media/contract-landing-hero.424f59c7.svg";